(() => {
  const overlay = document.querySelector('[data-search-overlay]');
  const panel = overlay?.querySelector('[data-search]');
  const form = panel?.querySelector('[data-search-form]');
  const input = form?.querySelector('[data-predictive-search-terms]');
  const results = form?.querySelector('[data-results-wrapper]');
  const recovery = form?.querySelector('[data-search-recovery]');
  const status = form?.querySelector('[data-search-status]');
  const skeleton = form?.querySelector('[data-search-skeleton]');
  if (document.body.dataset.predictiveSearch !== 'true' || !input || !results || !recovery) return;
  document.body.dataset.predictiveSearch = 'false';

  let open = false;
  let trigger;
  let timer;
  let activeRequest;
  let version = 0;
  let composing = false;
  let previousOverflow;

  function setLoading(loading) {
    results.setAttribute('aria-busy', String(loading));
    if (status) status.hidden = !loading;
    if (skeleton) skeleton.hidden = !loading;
  }

  function replaceResults(content) {
    results.dispatchEvent(new CustomEvent('theme:rimg:unwatch', { bubbles: true }));
    if (content) results.replaceChildren(content);
    else results.replaceChildren();
  }

  function invalidate() {
    version += 1;
    clearTimeout(timer);
    activeRequest?.abort();
    activeRequest = null;
    setLoading(false);
  }

  function close(returnFocus = false) {
    if (!open) return;
    open = false;
    invalidate();
    replaceResults();
    overlay.dataset.animationState = 'closed';
    panel.dataset.animationState = 'closed';
    document.body.style.overflow = previousOverflow;
    if (returnFocus && trigger?.isConnected) trigger.focus({ preventScroll: true });
  }

  async function getResults() {
    const query = input.value.trim();
    if (!open || !query || composing) return;
    invalidate();
    const requestVersion = version;
    const abort = new AbortController();
    activeRequest = abort;
    const timeout = setTimeout(() => abort.abort(), 15000);
    setLoading(true);
    try {
      const url = new URL(window.PXUTheme.routes.predictive_search_url, location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('section_id', 'predictive-search');
      const response = await fetch(url, { signal: abort.signal });
      if (!response.ok) throw new Error(`Search HTTP ${response.status}`);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = html.querySelector('.predictive-search__results');
      if (!content) throw new Error('Missing search results');
      if (requestVersion !== version || !open || input.value.trim() !== query) return;
      replaceResults(content);
      results.dispatchEvent(new CustomEvent('theme:rimg:watch', { bubbles: true }));
    } catch (_) {
      if (requestVersion !== version || !open || input.value.trim() !== query) return;
      replaceResults(recovery.content.cloneNode(true));
    } finally {
      clearTimeout(timeout);
      if (requestVersion === version) {
        activeRequest = null;
        setLoading(false);
      }
    }
  }

  function schedule() {
    invalidate();
    replaceResults();
    if (open && input.value.trim() && !composing) timer = setTimeout(getResults, 300);
  }

  document.addEventListener('click', event => {
    if (form.contains(event.target) && event.target.closest('[data-search-retry]')) {
      input.focus({ preventScroll: true });
      replaceResults();
      getResults();
      return;
    }
    const opener = event.target.closest('[data-search-open]');
    if (opener) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      trigger = opener;
      if (!open) {
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        open = true;
        overlay.dataset.animationState = 'open';
        panel.dataset.animationState = 'open';
        input.focus({ preventScroll: true });
        schedule();
      }
      return;
    }
    if (event.target.closest('[data-close-search]')) close(true);
    else if (open && !panel.contains(event.target)) close(true);
  });

  document.addEventListener('focusin', event => {
    if (open && !panel.contains(event.target)) close();
  });
  window.addEventListener('keydown', event => {
    if (open && event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      close(true);
    }
  });
  input.addEventListener('input', schedule);
  input.addEventListener('compositionstart', () => {
    composing = true;
    invalidate();
    replaceResults();
  });
  input.addEventListener('compositionend', () => {
    composing = false;
    schedule();
  });
  form.addEventListener('submit', event => {
    if (!input.value.trim()) event.preventDefault();
  });
})();
